import React from "react";
import { GoalsView } from "../goals/GoalsView";

export function GoalsTab({ studentId }) {
  return <GoalsView studentId={studentId} />;
}
